import React from 'react';
import {Helmet} from "react-helmet";

export default function PersonalDataPolicy() {
    return (<>
        <Helmet>
            <title>Политика обработки персональных данных - ДавайНаСвидание</title>
        </Helmet>
        <div className="bg-background1 pt-14 pb-20">
            <section>
                <div className="container mx-auto">
                    <div>
                        <h2 className="text-xl lg:text-2xl font-bold text-blue uppercase">ПОЛИТИКА
                            обработки персональных данных </h2>
                        <p className="text-right">
                            <br/>ИП АНТОНЕНКО ЮЛИЯ СЕРГЕЕВНА
                            <br/>ИНН 482412725308 ОГРН 326774600118559
                            <br/>09.03.2021 № 1
                            <br/>г. Москва
                        </p>

                        <p>
                            <br />1. ОБЩИЕ ПОЛОЖЕНИЯ
                            <br />1.1. Настоящая Политика ИП Антоненко Ю. С. в отношении обработки персональных данных (далее –
                            Политика) разработана во
                            исполнение требований п. 2 ч. 1 ст. 18.1 Федерального закона от 27.07.2006 № 152-ФЗ «О
                            персональных данных»
                            (далее – Закон о персональных данных) в целях обеспечения защиты прав и свобод человека и
                            гражданина при
                            обработке его персональных данных, в том числе защиты прав на неприкосновенность частной
                            жизни, личную и
                            семейную тайну.
                            <br />1.2. Политика действует в отношении всех персональных данных, которые обрабатывает
                            ИП Антоненко Ю. С. (далее — Оператор, ИП Антоненко Ю. С.).
                            <br />1.3. Политика распространяется на отношения в области обработки персональных данных,
                            возникшие у Оператора как
                            до, так и после утверждения настоящей Политики.
                            <br />1.4. Во исполнение требований ч. 2 ст. 18.1 Закона о персональных данных настоящая Политика
                            публикуется в
                            свободном доступе в информационно-телекоммуникационной сети Интернет на сайте Оператора.
                            <br />1.5. В Политике используются термины и определения в соответствии с их значениями,
                            определенными в Законе о
                            персональных данных.
                            <br />1.6. Основные права и обязанности Оператора.
                            <br />1.6.1. Оператор имеет право:
                            <br />– самостоятельно определять состав и перечень мер, необходимых и достаточных для обеспечения
                            выполнения
                            обязанностей, предусмотренных Законом о персональных данных и принятыми в соответствии с ним
                            нормативными
                            правовыми актами, если иное не предусмотрено Законом о персональных данных или другими
                            федеральными законами;
                            <br />– поручить обработку персональных данных другому лицу с согласия субъекта персональных
                            данных, если иное не
                            предусмотрено федеральным законом, на основании заключаемого с этим лицом договора. Лицо,
                            осуществляющее
                            обработку персональных данных по поручению Оператора, обязано соблюдать принципы и правила
                            обработки
                            персональных данных, предусмотренные Законом о персональных данных;
                            <br />– в случае отзыва субъектом персональных данных согласия на обработку персональных данных
                            Оператор вправе
                            продолжить обработку персональных данных без согласия субъекта персональных данных при
                            наличии оснований,
                            указанных в Законе о персональных данных.
                            <br />1.6.2. Оператор обязан:
                            <br />– организовывать обработку персональных данных в соответствии с требованиями Закона о
                            персональных данных;
                            <br />– отвечать на обращения и запросы субъектов персональных данных и их законных представителей
                            в соответствии с
                            требованиями Закона о персональных данных;
                            <br />– сообщать в уполномоченный орган по защите прав субъектов персональных данных (Федеральную
                            службу по надзору в
                            сфере связи, информационных технологий и массовых коммуникаций (Роскомнадзор)) по запросу
                            этого органа
                            необходимую информацию в течение 10 рабочих дней с даты получения такого запроса. Данный
                            срок может быть
                            продлен, но не более чем на пять рабочих дней. Для этого Оператору необходимо направить в
                            Роскомнадзор
                            мотивированное уведомление с указанием причин продления срока предоставления запрашиваемой
                            информации;
                            <br />- в порядке, определенном федеральным органом исполнительной власти, уполномоченным в
                            области обеспечения
                            безопасности, обеспечивать взаимодействие с государственной системой обнаружения,
                            предупреждения и ликвидации
                            последствий компьютерных атак на информационные ресурсы РФ, включая информирование его о
                            компьютерных
                            инцидентах, которые повлекли неправомерную передачу (предоставление, распространение,
                            доступ) персональных
                            данных.
                            <br />1.7. Основные права субъекта персональных данных.&nbsp;
                            <br />1.7.1. Субъект персональных данных имеет право:
                            <br />– получать информацию, касающуюся обработки его персональных данных, за исключением случаев,
                            предусмотренных
                            федеральными законами. Сведения предоставляются субъекту персональных данных Оператором в
                            доступной форме, и в
                            них не должны содержаться персональные данные, относящиеся к другим субъектам персональных
                            данных, за
                            исключением случаев, когда имеются законные основания для раскрытия таких персональных
                            данных. Перечень
                            информации и порядок ее получения установлен Законом о персональных данных;
                            <br />– требовать от Оператора уточнения его персональных данных, их блокирования или уничтожения
                            в случае, если
                            персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не
                            являются
                            необходимыми для заявленной цели обработки, а также принимать предусмотренные законом меры
                            по защите своих прав;
                            <br />– дать предварительное согласие на обработку персональных данных в целях продвижения на
                            рынке товаров, работ и
                            услуг;
                            <br />– обжаловать в Роскомнадзоре или в судебном порядке неправомерные действия или бездействие
                            Оператора при
                            обработке его персональных данных.
                            <br />1.8. Контроль за исполнением требований настоящей Политики осуществляется уполномоченным
                            лицом, ответственным за
                            организацию обработки персональных данных у Оператора.
                            <br />1.9. Ответственность за нарушение требований законодательства Российской Федерации и
                            нормативных актов ИП Антоненко Ю. С. в сфере обработки и защиты персональных данных определяется
                            в соответствии с законодательством Российской Федерации.
                        </p>
                        <p>
                            <br />2. ЦЕЛИ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ
                            <br />2.1. Обработка персональных данных ограничивается достижением конкретных, заранее
                            определенных и законных целей.
                            Не допускается обработка персональных данных, несовместимая с целями сбора персональных
                            данных.
                            <br />2.2. Обработке подлежат только персональные данные, которые отвечают целям их обработки.
                            <br />2.3. Обработка Оператором персональных данных ведется в следующих целях:
                            <br />– обеспечение соблюдения Конституции РФ, федеральных законов и иных нормативных правовых
                            актов Российской
                            Федерации;
                            <br />– осуществление своей деятельности ИП Антоненко Ю. С.;
                            <br />– ведение кадрового делопроизводства;
                            <br />– заключение и исполнение гражданско-правовых договоров;
                            <br />– ведение бухгалтерского учета.
                            <br />2.4. Обработка персональных данных работников может осуществляться исключительно в целях
                            обеспечения соблюдения
                            законов и иных нормативных правовых актов.
                        </p>
                        <p>
                            <br />3. ПРАВОВОЕ ОСНОВАНИЕ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ
                            <br />3.1. Правовым основанием обработки персональных данных является совокупность нормативных
                            правовых актов, во
                            исполнение которых и в соответствии с которыми Оператор осуществляет обработку персональных
                            данных, в том числе:
                            <br />– Конституция РФ;
                            <br />– Гражданский кодекс РФ;
                            <br />– Трудовой кодекс РФ;
                            <br />– Налоговый кодекс РФ;
                            <br />– Федеральный закон от 27.07.2006 № 152-ФЗ «О персональных данных»;
                            <br />– Федеральный закон от 27.07.2006 № 149-ФЗ «Об информации, информационных технологиях и
                            защите
                            информации»;&nbsp;
                            <br />– Федеральный закон от 08.02.1998 № 14-ФЗ «Об обществах с ограниченной ответственностью»;
                            <br />– Федеральный закон от 06.12.2011 № 402-ФЗ «О бухгалтерском учете»;
                            <br />– Федеральный закон от 15.12.2001 № 167-ФЗ «Об обязательном пенсионном страховании в
                            Российской Федерации»;
                            <br />– «Требования к защите персональных данных при их обработке в информационных системах
                            персональных данных», утв.
                            постановлением Правительства РФ от 01.11.2012 № 1119;
                            <br />– иные нормативные правовые акты, регулирующие деятельность Оператора;
                            <br />– договоры, заключаемые между Оператором и субъектами персональных данных;
                            <br />– согласие субъектов персональных данных на обработку их персональных данных.
                        </p>
                        <p>
                            <br />4. СОСТАВ, ОБЪЕМ И КАТЕГОРИИ ОБРАБАТЫВАЕМЫХ ПЕРСОНАЛЬНЫХ ДАННЫХ
                            <br />4.1. Содержание и объем обрабатываемых персональных данных должны соответствовать заявленным
                            целям обработки,
                            предусмотренным в разделе 2 настоящей Политики. Обрабатываемые персональные данные не должны
                            быть избыточными по
                            отношению к заявленным целям их обработки.
                            <br />Запрещается отказывать в обработке данных (обслуживании), если субъект персональных данных
                            отказывается
                            предоставить биометрические персональные данные и (или) дать согласие на обработку
                            персональных данных, если в
                            соответствии с федеральным законом получение оператором согласия на обработку персональных
                            данных не является
                            обязательным.
                            <br />4.2. Оператор может обрабатывать персональные данные следующих категорий субъектов
                            персональных данных.
                            <br />4.2.1. Кандидаты для приема на работу к Оператору:
                            <br />– фамилия, имя, отчество;
                            <br />– пол;
                            <br />– гражданство;
                            <br />– дата и место рождения;
                            <br />– контактные данные;
                            <br />– сведения об образовании, опыте работы, квалификации;
                            <br />– иные персональные данные, сообщаемые кандидатами в резюме и сопроводительных письмах.
                            <br />4.2.2. Работники (в том числе бывшие) Оператора:
                            <br />– фамилия, имя, отчество (при наличии), а также прежние фамилия, имя, отчество (при
                            наличии), дата и место их
                            изменения (в случае изменения);
                            <br />- пол;
                            <br />– дата (число, месяц, год) и место рождения работника;
                            <br />- сведения о гражданстве;
                            <br />- вид, серия, номер документа, удостоверяющего личность, наименование органа, выдавшего его,
                            дата выдачи;
                            <br />- страховой номер индивидуального лицевого счета (СНИЛС);
                            <br />- идентификационный номер налогоплательщика (ИНН);
                            <br />– адрес и дата регистрации по месту жительства (месту пребывания), адрес фактического
                            проживания;
                            <br />- сведения о семейном положении, составе семьи (степень родства, фамилии, имена, отчества
                            (при наличии), даты
                            (число, месяц, год) и места рождения);
                            <br />– сведения об образовании и (или) квалификации или наличии специальных знаний (в том числе
                            наименование
                            образовательной и (или) иной организации, год окончания, уровень образования, квалификация,
                            реквизиты документа
                            об образовании, обучении);
                            <br />– информация о владении иностранными языками;
                            <br />- сведения об отношении к воинской обязанности, о воинском учете и реквизиты документов
                            воинского учета (серия,
                            номер, дата выдачи документа, наименование органа, выдавшего его);
                            <br />- сведения о трудовой деятельности, а также информация о предыдущих местах работы, периодах
                            и стаже работы;
                            <br />- сведения, содержащиеся в документах, дающих право на пребывание и трудовую деятельность на
                            территории РФ (для
                            иностранных граждан, пребывающих в РФ);
                            <br />- сведения, содержащиеся в разрешении на временное проживание, разрешении на временное
                            проживание в целях
                            получения образования (для иностранных граждан, временно проживающих в РФ), виде на
                            жительство (для иностранных
                            граждан, постоянно проживающих в РФ);
                            <br />- сведения о доходах, обязательствах по исполнительным документам;
                            <br />- номера расчетного счета, банковской карты;
                            <br />– иные персональные данные, предоставляемые работниками в соответствии с требованиями
                            трудового
                            законодательства.
                            <br />4.2.3. Члены семей работников Оператора:
                            <br />– фамилия, имя, отчество;
                            <br />– степень родства;
                            <br />– дата рождения;
                            <br />– иные персональные данные, предоставляемые работниками в соответствии с требованиями
                            трудового
                            законодательства.
                            <br />4.2.4. Клиенты и контрагенты Оператора (физические лица) - для целей осуществления своей
                            деятельности в
                            соответствии с уставом ИП Антоненко Ю. С.:
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; фамилия, имя, отчество;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; дата и место рождения;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; паспортные данные;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; адрес регистрации по месту жительства;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; контактные данные;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; индивидуальный номер налогоплательщика;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; номер расчетного счета;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; иные персональные данные, предоставляемые клиентами и
                            контрагентами (физическими
                            лицами), необходимые для заключения и исполнения договоров.
                            <br />4.2.5. Представители (работники) контрагентов Оператора (юридических лиц и индивидуальных
                            предпринимателей) -
                            для целей осуществления своей деятельности в соответствии с уставом ИП Антоненко Ю. С.:
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; фамилия, имя, отчество;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; контактные данные;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; замещаемая должность;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; иные персональные данные, предоставляемые представителями
                            (работниками) клиентов и
                            контрагентов, необходимые для заключения и исполнения договоров.
                            <br />4.2.6. Посетители сайта - для целей осуществления своей деятельности в соответствии с
                            уставом ИП Антоненко Ю. С.:
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; фамилия, имя, отчество;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; адрес электронной почты;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; телефон.
                            <br />4.3. Обработка Оператором биометрических персональных данных (сведений, которые
                            характеризуют физиологические и
                            биологические особенности человека, на основании которых можно установить его личность)
                            ведется в соответствии с
                            законодательством Российской Федерации.
                            <br />4.4. Оператор не ведет обработку специальных категорий персональных данных, касающихся
                            расовой, политических
                            взглядов, религиозных или философских убеждений, интимной жизни, за исключением случаев,
                            предусмотренных
                            законодательством РФ.
                        </p>
                        <p>
                            <br />5. ПОРЯДОК И УСЛОВИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ
                            <br />5.1. Обработка персональных данных осуществляется Оператором в соответствии с требованиями
                            законодательства
                            Российской Федерации.
                            <br />5.2. Обработка персональных данных осуществляется с согласия субъектов персональных данных
                            на обработку их
                            персональных данных, а также без такового в случаях, предусмотренных законодательством
                            Российской Федерации.
                            <br />5.3. Оператор осуществляет обработку персональных данных для каждой цели их обработки
                            следующими способами:
                            <br />- неавтоматизированная обработка персональных данных;
                            <br />- автоматизированная обработка персональных данных с передачей полученной информации по
                            информационно-телекоммуникационным сетям или без таковой;
                            <br />- смешанная обработка персональных данных.
                            <br />5.4. К обработке персональных данных допускаются работники Оператора, в должностные
                            обязанности которых входит
                            обработка персональных данных.
                            <br />5.5. Обработка персональных данных для каждой цели обработки, указанной в п. 2.3 Политики,
                            осуществляется путем:
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; получения персональных данных в устной и письменной форме
                            непосредственно от
                            субъектов персональных данных;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; внесения персональных данных в журналы, реестры и
                            информационные системы Оператора;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; использования иных способов обработки персональных данных.
                            <br />5.6. Не допускается раскрытие третьим лицам и распространение персональных данных без
                            согласия субъекта
                            персональных данных, если иное не предусмотрено федеральным законом. Согласие на обработку
                            персональных данных,
                            разрешенных субъектом персональных данных для распространения, оформляется отдельно от иных
                            согласий субъекта
                            персональных данных на обработку его персональных данных.
                            <br />Требования к содержанию согласия на обработку персональных данных, разрешенных субъектом
                            персональных данных для
                            распространения, утверждены Приказом Роскомнадзора от 24.02.2021 N 18.
                            <br />5.7. Передача персональных данных органам дознания и следствия, в Федеральную налоговую
                            службу, Социальный фонд
                            России и другие уполномоченные органы исполнительной власти и организации осуществляется в
                            соответствии с
                            требованиями законодательства Российской Федерации.
                            <br />5.8. Оператор принимает необходимые правовые, организационные и технические меры для защиты
                            персональных данных
                            от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования,
                            распространения и других
                            несанкционированных действий, в том числе:
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; определяет угрозы безопасности персональных данных при их
                            обработке;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; принимает локальные нормативные акты и иные документы,
                            регулирующие отношения в
                            сфере обработки и защиты персональных данных;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; назначает лиц, ответственных за обеспечение безопасности
                            персональных данных в
                            структурных подразделениях и информационных системах Оператора;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; создает необходимые условия для работы с персональными данными;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; организует учет документов, содержащих персональные данные;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; организует работу с информационными системами, в которых
                            обрабатываются
                            персональные данные;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; хранит персональные данные в условиях, при которых
                            обеспечивается их сохранность и
                            исключается неправомерный доступ к ним;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; организует обучение работников Оператора, осуществляющих
                            обработку персональных
                            данных.
                            <br />5.9. Оператор осуществляет хранение персональных данных в форме, позволяющей определить
                            субъекта персональных
                            данных, не дольше, чем этого требует каждая цель обработки персональных данных, если срок
                            хранения персональных
                            данных не установлен федеральным законом, договором.
                            <br />5.9.1. Персональные данные на бумажных носителях хранятся в ИП Антоненко Ю. С. в течение сроков
                            хранения документов, для
                            которых эти сроки предусмотрены законодательством об архивном деле в РФ (Федеральный закон
                            от 22.10.2004 N
                            125-ФЗ "Об архивном деле в Российской Федерации", Перечень типовых управленческих архивных
                            документов,
                            образующихся в процессе деятельности государственных органов, органов местного
                            самоуправления и организаций, с
                            указанием сроков их хранения (утв. Приказом Росархива от 20.12.2019 N 236)).
                            <br />5.9.2. Срок хранения персональных данных, обрабатываемых в информационных системах
                            персональных данных,
                            соответствует сроку хранения персональных данных на бумажных носителях.
                            <br />5.10. Оператор прекращает обработку персональных данных в следующих случаях:
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; выявлен факт их неправомерной обработки. Срок - в течение трех
                            рабочих дней с даты
                            выявления;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; достигнута цель их обработки;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; истек срок действия или отозвано согласие субъекта персональных
                            данных на обработку
                            указанных данных, когда по Закону о персональных данных обработка этих данных допускается
                            только с согласия.
                            <br />5.11. При достижении целей обработки персональных данных, а также в случае отзыва субъектом
                            персональных данных
                            согласия на их обработку Оператор прекращает обработку этих данных, если:
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; иное не предусмотрено договором, стороной которого,
                            выгодоприобретателем или
                            поручителем по которому является субъект персональных данных;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; Оператор не вправе осуществлять обработку без согласия субъекта
                            персональных данных
                            на основаниях, предусмотренных Законом о персональных данных или иными федеральными
                            законами;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; иное не предусмотрено другим соглашением между Оператором и
                            субъектом персональных
                            данных.
                            <br />5.12. При обращении субъекта персональных данных к Оператору с требованием о прекращении
                            обработки персональных
                            данных в срок, не превышающий 10 рабочих дней с даты получения Оператором соответствующего
                            требования, обработка
                            персональных данных прекращается, за исключением случаев, предусмотренных Законом о
                            персональных данных.
                            Указанный срок может быть продлен, но не более чем на пять рабочих дней. Для этого Оператору
                            необходимо
                            направить субъекту персональных данных мотивированное уведомление с указанием причин
                            продления срока.
                            <br />5.13. При сборе персональных данных, в том числе посредством
                            информационно-телекоммуникационной сети Интернет,
                            Оператор обеспечивает запись, систематизацию, накопление, хранение, уточнение (обновление,
                            изменение),
                            извлечение персональных данных граждан Российской Федерации с использованием баз данных,
                            находящихся на
                            территории Российской Федерации, за исключением случаев, указанных в Законе о персональных
                            данных.
                        </p>
                        <p>
                            <br />6. ИНЫЕ ДЕЙСТВИЯ С ПЕРСОНАЛЬНЫМИ ДАННЫМИ. ДОСТУП К ПЕРСОНАЛЬНЫМ ДАННЫМ
                            <br />6.1. Подтверждение факта обработки персональных данных Оператором, правовые основания и цели
                            обработки
                            персональных данных, а также иные сведения, указанные в ч. 7 ст. 14 Закона о персональных
                            данных,
                            предоставляются Оператором субъекту персональных данных или его представителю при обращении
                            либо при получении
                            запроса субъекта персональных данных или его представителя.&nbsp;
                            <br />Ответ Оператора на запрос (обращение) субъекта о предоставлении информации, касающейся
                            обработки его
                            персональных данных, должен быть дан в течение десяти рабочих дней с момента обращения либо
                            получения Оператором
                            запроса субъекта персональных данных или его представителя. Указанный срок может быть
                            продлен, но не более чем
                            на пять рабочих дней в случае направления Оператором в адрес субъекта персональных данных
                            мотивированного
                            уведомления с указанием причин продления срока предоставления запрашиваемой информации.
                            Ответ на запрос дается в
                            той форме, в которой направлен запрос (обращение), либо в форме, указанной в самом запросе
                            (обращении).&nbsp;
                            <br />В предоставляемые сведения не включаются персональные данные, относящиеся к другим субъектам
                            персональных
                            данных, за исключением случаев, когда имеются законные основания для раскрытия таких
                            персональных данных.
                            <br />Запрос должен содержать:
                            <br />– номер основного документа, удостоверяющего личность субъекта персональных данных или его
                            представителя,
                            сведения о дате выдачи указанного документа и выдавшем его органе;
                            <br />– сведения, подтверждающие участие субъекта персональных данных в отношениях с Оператором
                            (номер договора, дата
                            заключения договора, условное словесное обозначение и (или) иные сведения), либо сведения,
                            иным образом
                            подтверждающие факт обработки персональных данных Оператором;
                            <br />– подпись субъекта персональных данных или его представителя.
                            <br />Запрос может быть направлен в форме электронного документа и подписан электронной подписью в
                            соответствии с
                            законодательством Российской Федерации.
                            <br />Если в обращении (запросе) субъекта персональных данных не отражены в соответствии с
                            требованиями Закона о
                            персональных данных все необходимые сведения или субъект не обладает правами доступа к
                            запрашиваемой информации,
                            то ему направляется мотивированный отказ.
                            <br />Право субъекта персональных данных на доступ к его персональным данным может быть ограничено
                            в соответствии с ч.
                            8 ст. 14 Закона о персональных данных, в том числе если доступ субъекта персональных данных
                            к его персональным
                            данным нарушает права и законные интересы третьих лиц.
                            <br />6.2. В случае выявления неточных персональных данных при обращении субъекта персональных
                            данных или его
                            представителя либо по их запросу или по запросу Роскомнадзора Оператор блокирует
                            персональные данные,
                            относящиеся к этому субъекту, с момента такого обращения или получения указанного запроса на
                            период проверки,
                            если блокирование персональных данных не нарушает права и законные интересы субъекта
                            персональных данных или
                            третьих лиц.
                            <br />В случае подтверждения факта неточности персональных данных Оператор на основании сведений,
                            представленных
                            субъектом персональных данных или его представителем либо Роскомнадзором, или иных
                            необходимых документов
                            уточняет персональные данные в течение семи рабочих дней со дня представления таких сведений
                            и снимает
                            блокирование персональных данных.
                            <br />6.3. В случае выявления неправомерной обработки персональных данных при обращении (запросе)
                            субъекта
                            персональных данных или его представителя либо Роскомнадзора Оператор блокирует неправомерно
                            обрабатываемые
                            персональные данные, относящиеся к этому субъекту, с момента такого обращения или получения
                            запроса.
                            <br />6.4. При выявлении Оператором, Роскомнадзором или иным заинтересованным лицом факта
                            неправомерной или случайной
                            передачи (предоставления, распространения) персональных данных (доступа к персональным
                            данным), повлекшей
                            нарушение прав субъектов персональных данных, Оператор:
                            <br />- в течение 24 часов - уведомляет Роскомнадзор о произошедшем инциденте, предполагаемых
                            причинах, повлекших
                            нарушение прав субъектов персональных данных, предполагаемом вреде, нанесенном правам
                            субъектов персональных
                            данных, и принятых мерах по устранению последствий инцидента, а также предоставляет сведения
                            о лице,
                            уполномоченном Оператором на взаимодействие с Роскомнадзором по вопросам, связанным с
                            инцидентом;
                            <br />- в течение 72 часов - уведомляет Роскомнадзор о результатах внутреннего расследования
                            выявленного инцидента и
                            предоставляет сведения о лицах, действия которых стали его причиной (при наличии).
                            <br />6.5. Порядок уничтожения персональных данных Оператором.
                            <br />6.5.1. Условия и сроки уничтожения персональных данных Оператором:
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; достижение цели обработки персональных данных либо утрата
                            необходимости достигать
                            эту цель - в течение 30 дней;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; достижение максимальных сроков хранения документов, содержащих
                            персональные данные,
                            - в течение 30 дней;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; предоставление субъектом персональных данных (его
                            представителем) подтверждения
                            того, что персональные данные получены незаконно или не являются необходимыми для заявленной
                            цели обработки, - в
                            течение семи рабочих дней;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; отзыв субъектом персональных данных согласия на обработку его
                            персональных данных,
                            если их сохранение для цели их обработки более не требуется, - в течение 30 дней.
                            <br />6.5.2. При достижении цели обработки персональных данных, а также в случае отзыва субъектом
                            персональных данных
                            согласия на их обработку персональные данные подлежат уничтожению, если:
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; иное не предусмотрено договором, стороной которого,
                            выгодоприобретателем или
                            поручителем по которому является субъект персональных данных;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; Оператор не вправе осуществлять обработку без согласия субъекта
                            персональных данных
                            на основаниях, предусмотренных Законом о персональных данных или иными федеральными
                            законами;
                            <br />&nbsp; &nbsp; •&nbsp; &nbsp; иное не предусмотрено другим соглашением между Оператором и
                            субъектом персональных
                            данных.
                        </p>
                        <p>
                            <br />7. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ
                            <br />7.1. Настоящая Политика и изменения к ней утверждаются ИП Антоненко Ю. С..
                            <br />7.2. Все работники должны быть ознакомлены с текстом настоящей Политики и изменениями к ней
                            под подпись.
                            <br />7.3. Контроль за исполнением настоящей Политики возлагается на ИП Антоненко Ю. С..
                        </p>
                    </div>
                </div>
            </section>
        </div>
    </>);
}
